import { render } from "./ColorThemeImg.vue?vue&type=template&id=2ab15654&scoped=true"
import script from "./ColorThemeImg.vue?vue&type=script&lang=js"
export * from "./ColorThemeImg.vue?vue&type=script&lang=js"

import "./ColorThemeImg.vue?vue&type=style&index=0&id=2ab15654&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab15654"]])

export default __exports__